import { Option, Select, Stack, Typography } from "@mui/joy";
import { COLOR_PRIMARY } from "../../../utils/styles";

export const NONE = "None";
export const RESTAURANT_NAME_ASC = "Restaurant Name (A-Z)";
export const RESTAURANT_NAME_DESC = "Restaurant Name (Z-A)";
export const CORKAGE_FEE_ASC = "Corkage Fee (Low to High)";
export const CORKAGE_FEE_DESC = "Corkage Fee (High to Low)";
const SORT_OPTIONS = [
  NONE,
  RESTAURANT_NAME_ASC,
  RESTAURANT_NAME_DESC,
  CORKAGE_FEE_ASC,
  CORKAGE_FEE_DESC,
];

function SortMenu(props) {
  return (
    <Stack
      direction="row"
      spacing={1}
      sx={{
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <Typography
        level="body-sm"
        sx={{
          "&::selection": {
            backgroundColor: COLOR_PRIMARY,
          },
        }}
      >
        Sort:{" "}
      </Typography>
      <Select
        onChange={(event, newValue) => props.setSortBy(newValue)}
        defaultValue="None"
        size="sm"
        value={props.sortBy}
      >
        {SORT_OPTIONS.map((option) => (
          <Option value={option} key={option}>
            {option}
          </Option>
        ))}
      </Select>
    </Stack>
  );
}

export default SortMenu;
